import { render, staticRenderFns } from "./BuildiumBills.vue?vue&type=template&id=72d701da&scoped=true"
import script from "./BuildiumBills.vue?vue&type=script&lang=js"
export * from "./BuildiumBills.vue?vue&type=script&lang=js"
import style0 from "./BuildiumBills.vue?vue&type=style&index=0&id=72d701da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d701da",
  null
  
)

export default component.exports